import {
  get,
  post,
  postStore,
  createCacheAjax,
  retryAjax,
} from '@/utils/http/http'
import {
  FIXUP_URL,
  BILL_URL,
  LIVE_PALY_URL,
  SHOP_URL,
  LIVE_GW_URL,
  HOMEMINIURI,
  MARKET_URL,
  ZHIBO_URL,
  homeminiToLiveGw,
  VZAN_STORE_BASE_URL,
  liveGwRetry,
  wxHost,
} from '@/utils/http/baseUrl'
import qs from 'qs'
import StoreController from '@/controllers/storeController/view/store/store.controller.js'

export default {
  /* 账户信息 start */
  UserInfo: params =>
    get(`${FIXUP_URL}/api/v1/wx/indextemplate/user_info`, params, true),

  /* 注销账户信息 start */
  cancel: params =>
    post(`${ZHIBO_URL}/v1/user/cancel`, qs.stringify(params), false, {
      ContentType: 'application/x-www-form-urlencoded;charset=UTF-8',
    }),

  CheckPhoneAuthSceneNonLive: params =>
    post(`/liveajax/CheckPhoneAuthSceneNonLive`, qs.stringify(params), false, {
      ContentType: 'application/x-www-form-urlencoded;charset=UTF-8',
    }),

  SaveUserInfo: params =>
    post(`${FIXUP_URL}/api/v1/wx/indextemplate/save_user_info`, params, false),

  /* 购买记录 start */
  GetBuyLogList: params =>
    post(`${BILL_URL}/api/UserOrder/GetBuyLogList`, params, false),

  /* 最近浏览直播间 start */
  RecentlyBrowse: params =>
    get(`${LIVE_PALY_URL}/api/live/recently_browse`, params, true),

  /* 我的抽奖奖品 start */
  LotteryList: params =>
    post(`/marketing/wx/v1/lottery/mine/lottery_list`, params, false, {
      headers: {
        'token-payload': JSON.stringify({
          lid: params.zbId || window.zbvd.zbid,
        }),
      },
    }),

  /* 我的地址 start */
  addressList: params => post(`${SHOP_URL}/api/address/address`, params, false),

  // 删除收货地址记录
  del_address: params =>
    post(`${SHOP_URL}/api/address/del_address?id=${params.id}`, params, false),

  /* 用户同步微信信息 start */
  userWxinfo: params =>
    get(`${LIVE_PALY_URL}/api/live/user_sync_wxinfo`, params, true),

  /* 用户访问页面接口 start */
  userActRead: params =>
    get(`${LIVE_PALY_URL}/api/live/act_read`, params, false),

  /* 获取个人中心配置 start */
  getPersonCenterConfig: params =>
    get(`${LIVE_GW_URL}/generic/v1/homepage/personal/getConfig`, params, false),

  /* 获取消息数 start */
  getMessageInfo: params => post(`/liveajax/getappraisenum`, params, false),

  /* 获取用户会员信息 start */
  getUserMemberLevelInfo: params =>
    get(
      `${homeminiToLiveGw()}/api/MemberLevel/GetUserMemberLevelInfo`,
      params,
      false
    ),

  /* 获取个人中心用户信息 start */
  getUserInfo: params =>
    post(`${LIVE_GW_URL}/generic/v1/homepage/personal/userInfo`, params, false),

  /* 获取个人中心主题色 start */
  getPersonCenterTheme: params =>
    get(
      `${FIXUP_URL}/api/v1/siteinfo/get_site_attribute_value_cache`,
      params,
      false
    ),
  /* 获取个人中心用户积分 start */
  getUserIntegral: params =>
    post(
      `${LIVE_GW_URL}/integral/v1/h5/userDetail/getUserIntegralStatistics`,
      params,
      false
    ),

  /* 获取个人中心底部菜单 start */
  getBottomMenu: params =>
    get(
      `${FIXUP_URL}/api/v1/wx/indextemplate/get_bottomnaviga_info`,
      params,
      false
    ),

  /* 获取个人中心收益 start */
  getIncome: params =>
    post(`${BILL_URL}/api/UserCashLog/GetIncomePage`, params, false),

  /* 获取个人中心券码 start */
  getCouponNum: params =>
    post(`${MARKET_URL}/api/v1/coupon/getusercouponbaseinfo`, params, false),

  /* 获取个人中心当前用户直播id start */
  getCurUserLiveId: params =>
    post(
      `${LIVE_GW_URL}/generic/v1/homepage/personal/urlJumpFields`,
      params,
      false
    ),
  /* 获取个人中心当前用户关注数量 start */
  getUserLiveFocus: params =>
    post(
      `${LIVE_GW_URL}/generic/v1/homepage/personal/getUserLiveFocus`,
      params,
      false
    ),

  /* 获取个人中心底部菜单 start */
  getSalesManByCenter: params =>
    get(`${HOMEMINIURI}/api/Generalize/SalesManByCenter`, params, false),

  /* 获取用户是否注册直播间 */
  getIsShowCr: params =>
    get(`${LIVE_PALY_URL}/api/live/u_showcr`, params, false),

  /** 查询积分名称 */
  getIntegralBasic: params =>
    get(`${LIVE_GW_URL}/integral/v1/h5/basic/getIntegralBasic`, params, false),

  /**
   * @method 获取小程序首页导航列表(后台)
   */
  getMiniBottomNavigationList: params =>
    get(
      FIXUP_URL + '/api/v1/wx/indextemplate/get_mini_bottomnaviga_info',
      params,
      false
    ),
  /* 获取用户账号列表 start */
  getLoginUsers: params =>
    post(`${LIVE_PALY_URL}/api/auth/get_login_users`, params, false),
  /**
   * 获取我管理的直播间
   */
  getMyManageLive: params =>
    post(`/liveajax/GetMyMange?v=${Date.now()}`, params, false, { getRes: 1 }),
}
export const wkSign = params =>
  get(`${LIVE_PALY_URL}/api/live/wk_sign`, params, false)
export const GetWebChatSign = params =>
  get(`${wxHost}/liveajax/GetWebChatSign`, params, false)
// 检测是否授权手机号
export const checkPhoneAuth = params =>
  post(`/liveajax/CheckPhoneAuthSceneNonLive`, params, false)
// 商品订单badge
export const getOrderBadge = params =>
  post(`${BILL_URL}/api/UserOrder/GetOrderListCount`, params, false)

export const base_fields = params =>
  get(`${LIVE_PALY_URL}/api/live/base_fields`, params, false)

export const getVerifyRecord = params =>
  post(`${SHOP_URL}/api/v1/wx/verify/getSelfVerificationRecords`, params, false)

// 个人余额
export const getPersonalBalance = params =>
  retryAjax({
    retryUrl: `${liveGwRetry}/health/v1/h5/agent/getAgentCash`,
    requestFn: get,
    maxCount: 2,
  })(`${LIVE_GW_URL}/health/v1/h5/agent/getAgentCash`, params, false)

// 集卡合成记录
export const getComposeRecord = params => {
  const isStore = StoreController.isStore()
  return isStore
    ? postStore(
        `${LIVE_GW_URL}/health/v1/h5/store/manager/pageStoreCompoundRecord`,
        params,
        false
      )
    : post(
        `${LIVE_GW_URL}/health/v1/h5/collect-act/pageCompoundRecord`,
        params,
        false
      )
}

// 集卡领取记录
export const getReceivedRecord = params => {
  const isStore = StoreController.isStore()
  return isStore
    ? postStore(
        `${LIVE_GW_URL}/health/v1/h5/store/manager/pageStoreReceivedRecord`,
        params,
        false
      )
    : post(
        `${LIVE_GW_URL}/health/v1/h5/collect-act/pageReceivedRecord`,
        params,
        false
      )
}

// 集卡换奖励活动列表
export const getCollectCardData = params =>
  post(
    `${LIVE_GW_URL}/health/v1/h5/collect-act/pageActivityCard`,
    params,
    false
  )

// 代理邀请相关灰度接口
export const agentShareCardGray = params =>
  get(
    `${MARKET_URL}/api/v1/public/sharecard/agent_sharecard_gray`,
    params,
    false
  )

// 查询用户的会员付费入会记录
export const getMemberPayRecord = params =>
  post(
    `${LIVE_GW_URL}/marketing/api/MemberLevel/getMemberPayRecord`,
    params,
    false
  )

const _getMemberCustomTagList = createCacheAjax({
  requestType: 'post',
  timeout: 1000, // 1秒内多次调用只请求一次
})
// 获取会员自定义标识样式
export const getMemberCustomTagList = params =>
  _getMemberCustomTagList(
    `${LIVE_GW_URL}/marketing/v1/h5/memberCustomStyle/getMemberCustomStyleList`,
    params,
    false,
    { allRes: true }
  )
// 获取短链接
export function getShortLink(params) {
  return get(FIXUP_URL + `/api/v1/ShortLink/user/get_short_link`, params, false)
}
// 获取口令分享链接
export function getCommandLink(params) {
  return get(
    FIXUP_URL + `/api/v1/ShortLink/user/get_short_code_text`,
    params,
    false
  )
}
